/* Polyfill for customEvents - Internet Explorer 9 and higher */
(function () {
    if (typeof window.CustomEvent === 'function') return false;
    function CustomEvent(event: string, params: CustomEventInit) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent as any;
})();
/* End of polyfill */

interface EventListener {
    el: EventTarget;
    fn: EventListenerOrEventListenerObject;
    e: string;
}

function createEvent() {
    const listeners: EventListener[] = [];
    return (function () {
        return {
            addEvent(el: EventTarget, e: string, fn: EventListenerOrEventListenerObject, capture?: boolean) {
                if (el && el.addEventListener) {
                    el.addEventListener(e, fn, capture);
                } else if ((el as any).attachEvent) {
                    (el as any).attachEvent(e, fn);
                }
                listeners.push({ el, fn, e });
            },
            destroy(el: EventTarget, e: string, fn: EventListenerOrEventListenerObject) {
                const l = listeners.find((l) => {
                    return l.el === el && l.e === e && l.fn === fn;
                });
                if (l) {
                    l.el.removeEventListener(l.e, l.fn);
                }
            },
            destroyAll() {
                listeners.forEach((l) => {
                    l.el.removeEventListener(l.e, l.fn);
                });
            },
        };
    })();
}

const events = createEvent();

const viewEvents = Object.create(null, {
    listen: {
        value: function (selector: string, eventName: string, fn: EventListenerOrEventListenerObject) {
            this.eventName = eventName;
            this.element = document.querySelector(selector);
            events.addEvent(this.element, this.eventName, fn);
        },
    },
    broadcast: {
        value: function (view: string, payload: any) {
            this?.element?.dispatchEvent(
                new CustomEvent(this.eventName, {
                    detail: {
                        view: view,
                        payload: payload,
                    },
                })
            );
        },
    },
    destroy: {
        value: function (element: EventTarget, eventName: string, fn: EventListenerOrEventListenerObject) {
            if (element && eventName && fn) {
                events.destroy(element, eventName, fn);
                return;
            }
        },
    },
    destroyAll: {
        value: function () {
            events.destroyAll();
        },
    },
});

export default viewEvents;
